// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionCard_container__2P9EO","text-content":"SectionCard_text-content__eBgwH","title":"SectionCard_title__24H-Y","description":"SectionCard_description__15S1W"};